import WarehouseActions from './WarehouseActions';

export default WarehouseActions;
